/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useEffect } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { apiAssistant } from "../api/Assistant";
import clsx from "clsx";
import { useAccessId, useToken, useConfig } from "../hooks";
import { useLocalStorageState, useRequest } from "ahooks";
import iconTabBarUrl from "../assets/icon_tabbar.png";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import PersonIcon from "@mui/icons-material/Person";
import ExploreIcon from "@mui/icons-material/Explore";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import Home from "../components/Home";
import { FONT_SIZE_KEY, DEFAULT_FONT_SIZE } from "../context/FontSizeContext";

function TabBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [config, setConfig] = useConfig();
  const [token, setToken] = useToken();

  const getAssistant = () => {
    if (token) {
      return apiAssistant();
    } else {
      navigate("/login");
    }
  };

  const { data, loading } = useRequest(getAssistant, {
    refreshOnWindowFocus: true,
  });

  useEffect(() => {
    const storeConfig = async () => {
      if (!data?.ok) {
        return;
      }
      const resJson = await data?.json();
      if (resJson.code > 0) {
        setConfig(resJson.data);
        localStorage.setItem(
          FONT_SIZE_KEY,
          resJson.data.fontSize ?? DEFAULT_FONT_SIZE
        );
      }
    };
    if (!loading && data?.ok) {
      storeConfig();
    }
  }, [data, loading, setConfig]);

  return (
    <>
      <div className="weui-tab">
        <div className="weui-tab__panel">
          {location.pathname === "/" ? <Home config={config} /> : <Outlet />}
        </div>
        <div className="weui-tabbar">
          <div
            onClick={() => navigate("/")}
            className={clsx(
              "weui-tabbar__item",
              location.pathname === "/" && "weui-bar__item_on"
            )}
          >
            <div style={{ display: "inline-block", position: "relative" }}>
              {/* <img src={iconTabBarUrl} alt="" className="weui-tabbar__icon" /> */}
              <ChatBubbleIcon
                style={{
                  display: location.pathname === "/" ? "block" : "none",
                }}
                className="weui-tabbar__icon"
              />
              <ChatBubbleOutlineIcon
                style={{
                  display: location.pathname === "/" ? "none" : "block",
                }}
                className="weui-tabbar__icon"
              />
              {/* <span
                className="weui-badge"
                style={{ position: "absolute", top: "-2px", right: "-13px" }}
              >
                8
              </span> */}
            </div>
            <p className="weui-tabbar__label">提问</p>
          </div>
          <div
            onClick={() => navigate("/apps")}
            className={clsx(
              "weui-tabbar__item",
              location.pathname === "/apps" && "weui-bar__item_on"
            )}
          >
            <div style={{ display: "inline-block", position: "relative" }}>
              {/* <img src={iconTabBarUrl} alt="" className="weui-tabbar__icon" /> */}
              <PersonSearchIcon
                style={{
                  display: location.pathname === "/apps" ? "block" : "none",
                }}
                className="weui-tabbar__icon"
              />
              <PersonSearchOutlinedIcon
                style={{
                  display: location.pathname === "/apps" ? "none" : "block",
                }}
                className="weui-tabbar__icon"
              />
            </div>
            <p className="weui-tabbar__label">应用</p>
          </div>
          <div
            onClick={() => navigate("/explore")}
            className={clsx(
              "weui-tabbar__item",
              location.pathname === "/explore" && "weui-bar__item_on"
            )}
          >
            <div style={{ display: "inline-block", position: "relative" }}>
              {/* <img src={iconTabBarUrl} alt="" className="weui-tabbar__icon" /> */}
              <ExploreIcon
                style={{
                  display: location.pathname === "/explore" ? "block" : "none",
                }}
                className="weui-tabbar__icon"
              />
              <ExploreOutlinedIcon
                style={{
                  display: location.pathname === "/explore" ? "none" : "block",
                }}
                className="weui-tabbar__icon"
              />
              {/* <span
                className="weui-badge weui-badge_dot"
                style={{ position: "absolute", top: "0", right: "-6px" }}
              ></span> */}
            </div>
            <p className="weui-tabbar__label">发现</p>
          </div>
          <div
            onClick={() => navigate("/me")}
            className={clsx(
              "weui-tabbar__item",
              location.pathname === "/me" && "weui-bar__item_on"
            )}
          >
            <div style={{ display: "inline-block", position: "relative" }}>
              {/* <img src={iconTabBarUrl} alt="" className="weui-tabbar__icon" /> */}
              <PersonIcon
                style={{
                  display: location.pathname === "/me" ? "block" : "none",
                }}
                className="weui-tabbar__icon"
              />
              <PersonOutlinedIcon
                style={{
                  display: location.pathname === "/me" ? "none" : "block",
                }}
                className="weui-tabbar__icon"
              />
            </div>
            <p className="weui-tabbar__label">我</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default TabBar;
